<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
  >
    <path
      d="M0 4.68154C0 8.57194 3.216 10.6447 5.5696 12.5007C6.4 13.1551 7.2 13.7719 8 13.7719C8.8 13.7719 9.6 13.1559 10.4304 12.4999C12.7848 10.6455 16 8.57194 16 4.68234C16 0.791943 11.6 -1.96726 8 1.77354C4.4 -1.96806 0 0.791144 0 4.68154Z"
      fill="url(#paint0_angular_16703_272393)"
    />
    <defs>
      <radialGradient
        id="paint0_angular_16703_272393"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8 6.88597) rotate(83.7945) scale(6.92656 8.00152)"
      >
        <stop stop-color="#FF005C" />
        <stop offset="1" stop-color="#F75D5D" stop-opacity="0.43" />
      </radialGradient>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoginRespectIcon",
});
</script>

<style scoped lang="scss"></style>
